import deepMerge from 'deepmerge'
import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-chained-backend'
import HttpApi from 'i18next-http-backend'
import resourcesToBackend from 'i18next-resources-to-backend'
import { initReactI18next } from 'react-i18next'

import { isDevMode, SW_API_URL } from '@sportworld/js-sdk/src/envs/envs'
import { en, de } from '@sportworld/js-sdk/src/i18n'

const withBackend = true

const i18n = i18next.createInstance()
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: [
        'navigator',
        'querystring',
        'cookie',
        'localStorage',
        'sessionStorage',
        'navigator',
        'htmlTag',
        'path',
        'subdomain',
      ],
    },
    compatibilityJSON: 'v3',
    fallbackLng: 'en',
    debug: false,
    load: 'languageOnly',
    backend: withBackend
      ? {
          backends: [
            HttpApi,
            resourcesToBackend((lng: string) => getTranslation(lng)),
          ],
          backendOptions: [
            {
              /**
               * https://sportworld.api.dev.b1smarttv.com/locales/en
               * https://sportworld.api.dev.b1smarttv.com/locales/de
               */
              loadPath: `${SW_API_URL}/locales/{{lng}}`,
              parse: (data: string) => {
                return updateTranslation(data)
              },
            },
          ],
        }
      : {},
    react: {
      useSuspense: false,
      transKeepBasicHtmlNodesFor: ['span'],
    },
  })

export const getCurrentLanguage = () => {
  try {
    // This regex extracts the language code from a locale code. For example, it would extract "en" from "en-US".
    return i18n.language?.replace(/^(\w+)-(\w+)/, '$1')
  } catch (error) {
    return 'en'
  }
}

const updateTranslation = (data: string) => {
  const currentLanguage = getCurrentLanguage()
  const backendTranslation = JSON.parse(data)
  const localTranslation = getTranslation(currentLanguage) as any
  const translationResult = deepMerge(localTranslation, backendTranslation)
  isDevMode &&
    console.log({
      currentLanguage,
      localTranslation,
      backendTranslation,
      translationResult,
    })
  return translationResult
}

const getTranslation = (currentLanguage: string) => {
  switch (currentLanguage) {
    case 'de':
      return de.translation
    default:
      return en.translation
  }
}

export default i18n
